import React from 'react';
import { motion } from 'framer-motion';
export function Stats() {
  const stats = [{
    value: '15+',
    label: 'Communities Served'
  }, {
    value: '1.8k',
    label: 'Active Donors'
  }, {
    value: '$342k',
    label: 'Raised for 2026'
  }, {
    value: '100%',
    label: 'Committed to Local Control'
  }];
  return <section className="bg-pac-navy py-16 border-y-4 border-pac-gold" data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-179">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-180">
              <span className="font-serif text-4xl md:text-5xl font-bold text-white mb-2 drop-shadow-md" data-id="element-181">
                {stat.value}
              </span>
              <span className="text-sm md:text-base font-bold text-pac-gold uppercase tracking-wider" data-id="element-182">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}